module.exports = __webpack_public_path__ + "static/media/marketing_chat_light.aad52ccd.png";